import {
    MainFilterSelectedValuesApiType,
    MainFilterSelectedValuesIdsKeyEnum,
} from '../../service/main-filter/main-filter-api-type';
import {GroupOperationsEnum, MainFilterFieldNameEnum} from '../../service/main-filter/main-filter-type';
import {noop} from '../../util/function';

import {MainFilterContextType} from './main-filter-type';

export const defaultMainFilterContext: MainFilterContextType = {
    update: noop,
    state: {
        [MainFilterFieldNameEnum.NAMES]: [],
        [MainFilterFieldNameEnum.COUNTRIES]: [],
        [MainFilterFieldNameEnum.CODES]: [],
        [MainFilterFieldNameEnum.CITIES]: [],
        [MainFilterFieldNameEnum.STREETS]: [],
        [MainFilterFieldNameEnum.REGIONS]: [],
        [MainFilterFieldNameEnum.BRANDS]: [],
        [MainFilterFieldNameEnum.GROUPS]: [],
        [MainFilterFieldNameEnum.GROUPS_LOGICAL_OPERATION]: [],
        [MainFilterFieldNameEnum.CLOSED]: [],
        [MainFilterFieldNameEnum.ACTIVE]: [],
        [MainFilterFieldNameEnum.IS_PRIORITY_PLACEMENT]: [],
        [MainFilterFieldNameEnum.IS_PAID]: [],
        [MainFilterFieldNameEnum.NEED_MODERATE]: [],
    },
    filteredCount: 0,
    isLoadingInitialFilter: false,
    mainFilterKey: '',
};

export const filterActualizingIntervalMs = 12e4;

export const defaultEmptyFilterState: MainFilterSelectedValuesApiType = {
    [MainFilterSelectedValuesIdsKeyEnum.BRANDS]: [],
    [MainFilterSelectedValuesIdsKeyEnum.CITIES]: [],
    [MainFilterSelectedValuesIdsKeyEnum.STREETS]: [],
    [MainFilterSelectedValuesIdsKeyEnum.CODES]: [],
    [MainFilterSelectedValuesIdsKeyEnum.NAMES]: [],
    [MainFilterSelectedValuesIdsKeyEnum.COUNTRIES]: [],
    [MainFilterSelectedValuesIdsKeyEnum.REGIONS]: [],
    [MainFilterSelectedValuesIdsKeyEnum.GROUPS]: [],
    [MainFilterSelectedValuesIdsKeyEnum.GROUPS_LOGICAL_OPERATION]: GroupOperationsEnum.OR,
};
